import {
  Wrapper,
  Title,
  Content,
  Items,
  Item,
  ItemTitle,
  ItemText,
} from './styles'
import { BenefitsBlockProps } from './types'

export function BenefitsBlock({ items, title }: BenefitsBlockProps) {
  return (
    <Wrapper>
      <Content>
        <Title>{title}</Title>
        <Items>
          {items.map(({ id, title, text }) => (
            <Item key={id}>
              <ItemTitle>{title}</ItemTitle>
              <ItemText>{text}</ItemText>
            </Item>
          ))}
        </Items>
      </Content>
    </Wrapper>
  )
}
